export const decimalPattern = /^-?\d*[.,]?\d{0,2}$/;
export const noDecimalPattern = /^(\d+)$/;
export const maxFourDigitsPattern = /^(?:[0-9]{1,4}|\d{1,3}\.\d?)$/;
export const stringPattern = /([A-Z])\w+/;
export const emailPattern = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/;
